import {
  Box,
  Button,
  HStack,
  Table,
  Tbody,
  Td,
  Tr,
  VStack,
  IconButton
} from "@chakra-ui/react";
import React, { useEffect, useState, useCallback, useContext } from "react";
import RightMenu from "components/UI/RightMenu";
import { useParams } from "react-router";
import { axiosInstance } from "utils/axios";
import { Link } from "react-router-dom";
import { timestampToDate } from "utils/time";
import { useTranslate } from "hooks/useTranslate";
import { useResponsive } from "hooks/useResponsive";
import { ChevronUpIcon, ChevronDownIcon } from "@chakra-ui/icons";
import { ROLES} from "keys";
import { GlobalContext } from "context/GlobalContext";
import { VolumeSEO } from "components/SEO/VolumeSEO";

const VolumeAndIssueDetail = () => {
  const {IsMobile} = useResponsive();
  const IsRenderMobile = IsMobile();
  const { id: issueId } = useParams();
  const { t } = useTranslate();
  const { user } = useContext(GlobalContext);

  const [articles, setArticles] = useState([]);
  const [pageTitle, setPageTitle] = useState("");

  // Function to fetch articles based on issueId
  const fetchArticles = useCallback(() => {
    if (issueId === "0") {
      axiosInstance
        .get("/articles/waitlist_publication")
        .then((res) => setArticles(res.data))
        .catch((err) => console.log(err));
    } else {
      axiosInstance
        .get(`/articles?issue=${issueId}`)
        .then((res) => setArticles(res.data))
        .catch((err) => console.log(err));
    }
  }, [issueId]);

  // Fetch articles when the component mounts or when issueId changes
  useEffect(() => {
    fetchArticles();
    window.scrollTo(0, 0);
  }, [fetchArticles]);

  useEffect(() => {
    if (issueId === "0") {
      setPageTitle("ARTICLES IN PRESS");
    }
    // else if (articles.length > 0) {
    //   const issueName = articles[0]?.issue?.name?.toUpperCase() || "";
    //   const volumeName = articles[0]?.volume?.name?.toUpperCase() || "";
    //   setPageTitle(`${volumeName} - ${issueName}`);
    // }
    else 
      setPageTitle("");
  }, [issueId, articles]);

  // Function to handle moving articles up or down
  const handleMove = useCallback(async (articleId, direction) => {
    try {
      await axiosInstance.put(`/articles/${articleId}/order-paper`, { direction });
      fetchArticles(); // Refresh the articles list after moving
    } catch (err) {
      console.error(err);
    }
  }, [fetchArticles]);

  return (
    <>
      <VolumeSEO 
        volume={articles[0]?.volume}
        issue={articles[0]?.issue} 
        articles={articles}
      />
    
    <Box fontWeight='bold' pb="5">
      {pageTitle}
    </Box>
    
    <HStack align="flex-start" spacing="4" pb='2'>
      <VStack align="stretch" flex="1" spacing="8">
        {articles.map((article, idx) => (
          <Link to={`/articles/${article._id}`} key={article._id}>
            <VStack spacing="4" flex="1" align="stretch">
              <HStack justify="space-between" align="center">
                <Box
                  fontSize="lg"
                  fontWeight="semibold"
                  color="blue.600"
                  cursor="pointer"
                  _hover={{
                    textDecor: "underline",
                  }}
                  className="two-line-text"
                >
                  {article.info?.title}
                </Box>
                { (user?.role % ROLES.PUBLISHER === 0 
                    || user?.role % ROLES.ADMIN === 0
                    || user?.role % ROLES.EDITOR_IN_CHIEF === 0 ) && (
                  <HStack>
                    <IconButton
                      aria-label="Move Up"
                      icon={<ChevronUpIcon color="white" boxSize={5} />}
                      size="sm"
                      bg="blue.600"
                      color="white"
                      _hover={{ bg: "blue.700" }}
                      borderRadius="md" // square rounded
                      ml={2}
                      isDisabled={idx === 0}
                      onClick={e => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleMove(article._id, "up");
                      }}
                    />
                    <IconButton
                      aria-label="Move Down"
                      icon={<ChevronDownIcon color="white" boxSize={5} />}
                      size="sm"
                      bg="blue.600"
                      color="white"
                      _hover={{ bg: "blue.700" }}
                      borderRadius="md" // square rounded
                      ml={1}
                      isDisabled={idx === articles.length - 1}
                      onClick={e => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleMove(article._id, "down");
                      }}
                    />
                  </HStack>
                )}
              </HStack>
              <Box>
                {article.info?.authors
                  .map((author) => `${author.lastname} ${author.firstname}`)
                  .join("; ")}
              </Box>
              {/*<Box color="gray.500">
                {t("paper_published")}: {timestampToDate(article.publishedDate)}
                </Box>*/}
            </VStack>
            <hr />
          </Link>
        ))}
      </VStack>

      {!IsRenderMobile && 
        <RightMenu/>}
    </HStack>

    {IsRenderMobile && 
      <RightMenu/>}
  </>
  );
};

export default VolumeAndIssueDetail;
